'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstanceProperties = getInstanceProperties;

var _xr = require('xr');

var _xr2 = _interopRequireDefault(_xr);

var _getAppInfo2 = require('./getAppInfo');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function addStyle(css) {
  var head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
  style.type = 'text/css';

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);
}

function getInstanceProperties(url) {
  var _getAppInfo = (0, _getAppInfo2.getAppInfo)(),
      instance = _getAppInfo.instance;

  if (instance != null) {
    return new Promise(function (resolve, reject) {
      _xr2.default.get(url + instance + '/').then(function (resp) {
        var _resp$data = resp.data,
            assets = _resp$data.assets,
            options = _resp$data.options,
            css = _resp$data.css;

        if (css != null && css != '') {
          addStyle(css);
        }

        resolve({
          options: options,
          assets: assets
        });
      });
    });
  } else {
    return new Promise(function (resolve, reject) {
      resolve({
        options: {},
        assets: []
      });
    });
  }
}